import { Component } from '@angular/core';
import {AgGridAngular} from "ag-grid-angular";
import {AsyncPipe} from "@angular/common";
import {ChooseYourGameComponent} from "../../../components/choose-your-game/choose-your-game.component";
import {ContainerComponent} from "@coreui/angular";
import {IGameQueryResult} from "../../../interfaces/IGameQueryResult";
import {WinnerPayoutsComponent} from "../winner-payouts.component";

@Component({
  selector: 'app-cross-game-winner-payouts',
  standalone: true,
  imports: [
    AgGridAngular,
    AsyncPipe,
    ChooseYourGameComponent,
    ContainerComponent,
    WinnerPayoutsComponent
  ],
  templateUrl: './cross-game-winner-payouts.component.html',
  styleUrl: './cross-game-winner-payouts.component.css'
})
export class CrossGameWinnerPayoutsComponent  {

  protected game: IGameQueryResult | null = null;

  onGameChosen(chosenGameP: IGameQueryResult) {
    this.game = chosenGameP;
  }
}
